
(function($) {
	App._base = {
		proxy: function (func) {
			var self = this;
			return function() {
				return func.apply(self, arguments);
			};
		},

		isMobile: function() {
			var ww = $(window).width();
			return ww < 768;
		},

		isTablet: function(checkTouch) {
			var ww = $(window).width(),
				t = checkTouch || Modernizr.touch;
			return ww < 897 && t;
		},

		removeHash: function() { 
    		history.pushState('', 
    			document.title,
    			window.location.pathname + window.location.search
    		);
		}
	};
})(jQuery);  

